export default {
  events: [],
  quicklinks: [],
  dashboardevents: [],
  ownersByEventId: []
}
